<template>
  <div class="com" :class="isMobile() ? 'mobile' : 'desktop'">
    <div class="box" v-loading="loadingCom || loadingDocs" :style="{ height: (contenitoreHeight) + 'px' }">
      <docs-header-mobile :route="'DocumentiPers'" :showFilter="showFilter" :defaultMonths="defaultMonths"
        :title="$i18n.t(this.$route.name + '.label')" @changeMonth="changeMonth" class="top-block"
        :style="{ height: 80 + 'px' }" v-if="isMobile()"></docs-header-mobile>
      <docs-header :route="'DocumentiPers'" :showFilter="showFilter" :defaultMonths="defaultMonths"
        :title="$i18n.t(this.$route.name + '.label')" @changeMonth="changeMonth" class="top-block"
        :style="{ height: 60 + 'px' }" v-if="!isMobile()"></docs-header>
      <div class="box-documents" :style="{ height: (contenitoreHeight - 80) + 'px' }">
        <div class="gridMessage">
          <div class="row row-custom msgDetail">
            <div :class="[isMobile() ? 'col-24' : 'col-xl-6 col-lg-8 col-md-8 col-sm-8 col-8']" class="padding-2"
              v-for="(item, index) in com" :key="'as-' + index">
              <el-card shadow="never" :class="{ important: isImportant(item) }"
                @click.native="isMobile() ? selectMessage(item, index) : ''">
                <div class="card-testata col-24">
                  <div class="titolo">
                    {{ item.titolo.toUpperCase() }}
                  </div>
                  <div class="priorita" v-if="(item.priorita === '1')">
                    <icon name="riv-preferitiFull" scale="0.8"></icon>
                  </div>
                  <div class="allegati" v-if="(item.allegati.length > 0)">
                    <icon name="riv-attach" scale="1"></icon>
                  </div>
                  <div class="presa-vis" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'N')">
                    <icon name="riv-acceptView" scale="1"></icon>
                  </div>
                  <div class="presa-vis-yes" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'Y')">
                    <icon name="riv-read" scale="1"></icon>
                  </div>
                </div>
                <div class="col-24 testo truncate" v-html="item.testo"></div>
                <div class="col-24 footer no-padding">
                  <div class="data">
                    {{ $t('messages')[new Date(item.dataPub.substr(0, 4), parseInt(item.dataPub.substr(5, 2)) - 1,
                      item.dataPub.substr(8, 2)).getDay()] + ', ' + moment(item.dataPub,
                        'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
                  </div>
                  <el-button v-if="!isMobile()" class="WEB-button WEB-button-header"
                    @click.native="selectMessage(item, index)">{{ $t('docs.btn.leggi') }}</el-button>
                </div>
              </el-card>
            </div>
            <div v-for="(doc, index) in docs"
              :class="[isMobile() ? 'col-24' : 'col-xl-6 col-lg-8 col-md-8 col-sm-8 col-8']" class="padding-2"
              :key="'cm-' + index">

              <el-card shadow="never" :class="{ important: isImportant(doc) }"
                @click.native="isMobile() ? downloadPDF(doc) : false">
                <div class="card-testata col-24">
                  <div class="titolo">
                    {{ (doc.container) === undefined ? '' : $i18n.t('docs.documentType.'
                      + doc.container + '.label') }}
                  </div>
                  <div class="allegati">
                    <icon name="riv-attach" scale="1"></icon>
                  </div>
                  <div class="presa-vis" v-if="(doc.seRead === 'Y')">
                    <icon name="riv-acceptView" scale="1"></icon>
                  </div>

                </div>
                <div class="col-24 testo truncate" v-html="getTitolo(doc)"></div>
                <div class="col-24 footer no-padding">
                  <div class="data">
                    {{ getDate(doc) }}
                  </div>
                  <el-button v-if="!isMobile()" class="WEB-button WEB-button-header" @click.native="downloadPDF(doc)">{{
                    $t('docs.btn.download') }}</el-button>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog v-if="!isMobile()" class="modal-message" :visible.sync="showModal" @close="closeMessages" width="600px"
      :append-to-body="true" :title="messaggio.titolo.toUpperCase()" custom-class="custom-dialog">

      <div class="col-24 no-padding data">
        {{ $t('messages')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1,
          messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub,
            'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
      </div>
      <div class="col-24 no-padding data" v-if="(messaggio.hasOwnProperty('dataExp'))">
        {{ $t('messages.scade') + ' ' + moment(messaggio.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
      </div>
      <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
      <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
        <div v-for="mess in messaggio.allegati" :key="mess.keyDoc">
          <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
            <icon class="icona" name="riv-attach" scale="1"></icon>
            <div class="titolo-allegato">
              {{ mess.titolo }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button class="WEB-button WEB-button-primary"
            v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'N')"
            @click.native="setMessaggioService(messaggio, 'P', true)">
            {{ $t('docs.btn.presaVisione').toUpperCase() }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-if="isMobile()" class="modal-message-mobile mobile_customize" :visible.sync="showModal"
      @close="closeMessages" :append-to-body="true" :title="messaggio.titolo.toUpperCase()" custom-class="custom-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">

      <div class="col-24 no-padding data">
        {{ $t('messages')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1,
          messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub,
            'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
      </div>
      <div class="col-24 no-padding data" v-if="(messaggio.hasOwnProperty('dataExp'))">
        {{ $t('messages.scade') + ' ' + moment(messaggio.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
      </div>
      <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
      <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
        <div v-for="mess in messaggio.allegati" :key="mess.keyDoc">
          <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
            <icon class="icona" name="riv-attach" scale="1"></icon>
            <div class="titolo-allegato">
              {{ mess.titolo }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button class="WEB-button WEB-button-primary"
            v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'N')"
            @click.native="setMessaggioService(messaggio, 'P', true)">{{ $t('docs.btn.presaVisione') }}</el-button>
          <div v-else class="no-button" style="height:80px"></div>
          <el-button class="WEB-button WEB-button-alternative" @click="closeMessages()">{{ $t('docs.btn.close')
            }}</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import DocsHeader from './DocsHeader.vue'
import DocsHeaderMobile from './DocsHeaderMobile.vue'
import moment from 'moment'
import { bus } from "../Bus";
import mixinDownload from "../../assets/mixins/downloadDoc.js";

export default {
  components: {
    DocsHeader,
    DocsHeaderMobile
  },
  name: 'Comunicazioni',
  mixins: [mixinDownload],
  props: ['contenitoreHeight', 'showInDashboard', 'objComunicazione'],
  i18n: {},
  data() {
    return {
      moment: moment,
      baseUrl: process.env.baseUrl,
      docs: [],
      com: [],
      loadingCom: false,
      loadingDocs: false,
      showFilter: 'NO',
      heightHeader: 60,
      tipoCom: this.$route.meta.codePAS,
      url: this.$route.meta.urlCM,
      showModal: false,
      messaggio: {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      },
      indexMsg: '',
      defaultMonths: '0'
    }
  },
  activated: function () {
  },
  mounted: function () {
    this.$nextTick(() => {
      if (this.objComunicazione.codice !== undefined) {
        this.showFilter = this.showInDashboard === true ? 'NO' : this.objComunicazione.showFilter
        this.defaultMonths = this.objComunicazione.mesi

        if (this.objComunicazione.codiCom !== undefined && this.objComunicazione.codiCom !== '') {
          this.loadCom(this.objComunicazione.mesi)
        }
        if (this.objComunicazione.codiCM !== undefined && this.objComunicazione.codiCM !== '') {
          this.loadDocs(this.objComunicazione.mesi)
        }
      }
    })
  },
  methods: {
    loadCom: function (mesi) {
      if (this.objComunicazione.showFilter === false) {
        mesi = mesi
      }
      this.loadingCom = true
      this.com = []
      var obj = {
        params: {
          seBlock: 'N',
          tipo: this.objComunicazione.codiCom,
          order: '',
          mesi: mesi
        }
      }
      this.$http.get('communication/' + this.$store.state.country + '/messaggi', obj).then(response => {
        if (response.body.rc === 0) {
          this.com = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
        this.loadingCom = false
      }, response => {
        this.loadingCom = false
      })
    },
    loadDocs: function (mesi) {
      let today = moment()
      let dataAl = today.format('YYYYMMDD')
      let dataDal = today.subtract(mesi, 'months').format('YYYYMMDD')
      if (this.showFilter === false) {
        mesi = mesi
      }
      this.loadingDocs = true
      var obj = {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          container: this.objComunicazione.codiCM,
          dataDal: dataDal,
          dataAl: dataAl,
          pag_from: 1,
          pag_for: 99
        }
      }
      //this.$http.get('docs/search/' + this.$store.state.country + '/' + this.objComunicazione.codiCM, obj).then(response => {
      this.$http.get('documenti/' + this.$store.state.country + '/lstdocdip', obj).then(response => {
        if (response.body.rc === 0) {
          this.docs = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
        this.loadingDocs = false
      }, response => {
        this.loadingDocs = false
        // this.$router.push({name: 'Login'})
      })
    },
    sortDocs: function (array) {
      return array.sort(function (a, b) {
        var x = a.anno + a.mese
        var y = b.anno + b.mese
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
    },
    changeMonth: function (month) {
      if (this.objComunicazione.codiCom !== undefined && this.objComunicazione.codiCom !== '') {
        this.loadCom(month)
      }
      if (this.objComunicazione.codiCM !== undefined && this.objComunicazione.codiCM !== '') {
        this.loadDocs(month)
      }
    },
    isImportant: function (messaggio) {
      if (messaggio.container === undefined) {
        if (messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'Y') {
          // Documenti a cui è stata fatta la Presa Visione
          return false
        } else if (messaggio.sePresaVis === 'N' && messaggio.seLetto === 'Y') {
          // Documenti senza Presa Visione che è già stato letto
          return false
        } else {
          return true
        }
      } else {
        if (messaggio.seRead === 'Y') {
          return false
        } else {
          return true
        }
      }
    },
    setMessaggioService: function (messaggio, operazione, closeModal) {
      let data = new FormData()
      data.append('id', messaggio.id)
      data.append('op', operazione)
      this.$http.post('communication/' + this.$store.state.country + '/messaggio', data)
        .then(response => {
          if (response.body.rc === 0) {

            // Se op L ricalcolo tutti i messaggi da leggere
            if (operazione === 'L') {
              let messaggiCount = this.$store.state.messaggiCount
              if (messaggiCount[messaggio.tipo] !== undefined && messaggiCount[messaggio.tipo] > 0) {
                messaggiCount[messaggio.tipo] = messaggiCount[messaggio.tipo] - 1
              }
              if (messaggiCount.totale !== undefined && messaggiCount.totale > 0) {
                messaggiCount.totale = messaggiCount.totale - 1
              }
              this.$store.commit('set', { key: 'messaggiCount', value: messaggiCount })
              bus.$emit('changeMessaggiCount')
            }
            // Togliere load e cambiare lo stato del documento letto
            if (this.indexMsg !== '' && operazione === 'L')
              this.$set(this.com[this.indexMsg], 'seLetto', 'Y')
            if (this.indexMsg !== '' && operazione === 'P')
              this.$set(this.com[this.indexMsg], 'presaVis', 'Y')
            // this.loadCom()
            if (closeModal) {
              this.$set(this, 'showModal', false)
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    selectMessage: function (item, index) {
      this.$set(this, 'showModal', true)
      this.$set(this, 'messaggio', item)
      this.$set(this, 'indexMsg', index)
      if (item.seLetto === 'N') {
        // Richiamo il servizio di Lettura del documento solo l aprima volta
        this.setMessaggioService(item, 'L', false)
      }
    },
    closeMessages: function () {
      this.$set(this, 'indexMsg', '')
      this.$set(this, 'showModal', false)
      let obj = {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      }
      this.$set(this, 'messaggio', obj)
    },
    getTitolo: function (doc) {
      if (doc.container === undefined) {
        return doc.oggetto
      } else if (doc.container == 'PAFPAGLETGEN') {
        return doc.tdo
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return doc.tit
      } else {
        return ''
      }
    },
    getDate: function (doc) {
      if (doc.container === undefined) {
        return ''
      } else if (doc.container == 'PAFPAGLETGEN') {
        return this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return doc.datada
      } else if (doc.container == 'PAIPAGMODCUD') {
        return doc.anno
      } else if (doc.mese && doc.anno) {
        return this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else {
        return ''
      }
    },
    getNome: function (doc) {
      if (doc.container === undefined) {
        return doc.oggetto
      } else if (doc.container == 'PAFPAGLETGEN') {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label') + + ' ' + doc.tdo
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return '[' + doc.datada + ']' + ' ' + doc.tit
      } else if (doc.container == 'PAIPAGMODCUD') {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label')
        return nome + ' ' + doc.anno
      } else if (doc.container === undefined) {
        return 'generic'
      } else {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label')
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    },
    getNomeUrl: function (doc) {
      if (doc.container == 'PAFPAGLETGEN') {
        let nome = this.$i18n.t('documentType.' + doc.container + '.label', { titolo: '' })
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return '[' + doc.datada + ']' + ' ' + doc.tit
      } else {
        let nome = this.$i18n.t('documentType.' + doc.container + '.label')
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    },
    downloadPDF: function (doc) {
      console.log("Comunicazioni.vue - downloadPDF: " + process.env.APP_ENV)
      if (['dev', 'qa'].includes(process.env.APP_ENV)) {
        let win = window.open('', '_blank')
        win.location.href = 'https://secureq.rivagroup.com/DocumentiTest/RivaAcciaio_Letterhead.pdf'
        win.focus()
        return
      }
      let keydoc = encodeURIComponent(doc.keydoc)
      let nome = ''
      // if (!this.browserVersion()) {
      //  nome = this.getNome(doc)
      // }
      let win = window.open('', '_blank')
      this.$http.get('portale/' + this.$store.state.country + '/getTokenDoc').then(response => {
        if (response.body.wsToken) {
          let url = ('download/cm?keyDoc=' + keydoc + '&container=' + doc.container + '&nameDoc=' + nome +
            '&token=' + response.body.wsToken)
          // let win = window.open(process.env.baseUrl + url, '_blank')
          win.location.href = process.env.baseUrlSpring + url
          win.focus()
          // Richiamo il servizio di lettura
          if (doc.seRead === 'N') {
            let obj = {
              'keyCM': doc.keydoc,
              'cliCM': doc.cliCM,
              'appCM': doc.appCM
            }
            this.$http.post('documenti/' + this.$store.state.country + '/savereaddoc', obj, {
              params: {
                codLang: sessionStorage.getItem('codLang')
              }
            })
              .then(response => {
                if (response.body.rc === 0) {
                  this.loadDocs(this.objComunicazione.mesi)
                } else {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
              })
          }
        } else {
          this.$message({
            showClose: true,
            message: 'Error creating token',
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";


.com {
  height: 100%;

  //padding: 10px;
  &.desktop {
    .box {
      overflow: auto;
      background-color: #F9F9F9;

      // border-radius: 5px;
      .top-block {
        background-color: #F9F9F9;
        width: 100%;
        z-index: 1;
      }

      .box-documents {
        overflow: auto;

        .gridDocs {
          overflow: auto;
          padding-left: 15px;
          padding-right: 15px;

          .padding-2 {
            padding-left: 3px;
            padding-right: 3px;
          }
        }

        .gridMessage {
          overflow: auto;
          padding-left: 15px;
          padding-right: 15px;

          .msgDetail {
            .padding-2 {
              padding-left: 3px;
              padding-right: 3px;
            }

            .el-card {
              width: 100%;
              height: 115px;
              float: left;
              margin-bottom: 10px;
              border-radius: 0px;
              //border-top-right-radius: 25px;
              padding: 5px 10px !important;

              // cursor: pointer;
              .el-card__body {
                padding: 0;
                height: 100%;

                .card-testata {
                  width: 100%;
                  height: 30px;
                  padding: 0 !important;
                  display: flex;
                  justify-content: space-between;

                  .titolo {
                    width: 80%;
                    .set-font(@family: 'os-semibold', @color: #007E85, @size: 16px);
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }

                  .priorita {
                    margin-left: 10px;

                    .fa-icon {
                      color: red;
                    }
                  }

                  .allegati {
                    .fa-icon {
                      color: #007E85;
                    }
                  }

                  .ricevuto {
                    .set-font(@color: @greenRiva, @size: 10px);
                    font-style: italic;
                    margin-top: 3px;
                  }

                  .presa-vis {
                    .fa-icon {
                      color: #007E85;
                    }
                  }

                  .presa-vis-yes {
                    .fa-icon {
                      color: @greenTick;
                    }
                  }
                }

                .testo {
                  height: 50px;
                  padding: 0 5px !important;
                  .set-font(@size: 12px; @color: @textTable);
                  text-align: left;
                  word-break: break-word;
                }

                .footer {
                  display: inline-block;

                  //position: absolute;
                  //bottom: 6px;
                  //left: 0;
                  //padding: 0 10px !important;
                  .data {
                    .set-font(@color: #9AA0A7, @size: 11px);
                    float: left;
                    line-height: 20px;
                    //font-style: italic;
                    padding-top: 2px;
                  }

                  .el-button {
                    width: 80px !important;
                    float: right;
                    padding: 0 6px;
                    height: 26px !important;
                    /*height: 23px;
                      line-height: 20px;
                      padding: 0 6px;
                      border-color: @oroRiva !important;
                      background-color: @oroRiva !important;*/
                  }

                  .skip {
                    float: right;
                    margin-right: 2px;
                    text-align: right;

                    .el-badge {
                      .fa-icon {
                        color: #007E85;
                      }

                      .el-badge__content {
                        border: none;
                        background-color: transparent;
                        color: #007E85;
                        right: 10px;
                      }
                    }
                  }
                }
              }
            }

            & .selected {
              background-color: @hoverTbl;
            }

            & .important {
              border-left: 3px solid @rossoRiva;

              .testo {
                word-break: break-word;
                .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
              }

              .footer {
                .data {
                  .set-font(@color: #9AA0A7, @size: 11px, @family: 'os-bold') !important;
                  font-style: normal;
                }
              }
            }
          }
        }
      }
    }
  }

  &.mobile {
    .box {
      .box-documents {
        overflow: auto;
        padding-bottom: 60px;

        .gridDocs {
          overflow: auto;

          //padding-left: 15px;
          //padding-right: 15px;
          .padding-2 {
            padding-left: 3px;
            padding-right: 3px;
          }
        }

        .gridMessage {
          overflow: auto;
          padding-left: 0px;
          padding-right: 0px;

          .padding-2 {
            padding-left: 3px;
            padding-right: 3px;
          }

          .el-card {
            width: 100%;
            height: 115px;
            float: left;
            margin-bottom: 10px;
            border-radius: 0px;
            padding: 5px 10px !important;
            cursor: pointer;

            .el-card__body {
              padding: 0;
              height: 100%;

              .card-testata {
                width: 100%;
                height: 30px;
                padding: 0 !important;
                display: flex;
                justify-content: space-between;

                .titolo {
                  width: 80%;
                  .set-font(@family: 'os-semibold', @color: @rossoRiva, @size: 16px);
                  text-align: left;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .priorita {
                  margin-left: 10px;

                  .fa-icon {
                    color: red;
                  }
                }

                .allegati {
                  .fa-icon {
                    color: @rossoRiva;
                  }
                }

                .ricevuto {
                  .set-font(@color: @greenRiva, @size: 10px);
                  font-style: italic;
                  margin-top: 3px;
                }

                .presa-vis {
                  .fa-icon {
                    color: @rossoRiva;
                  }
                }

                .presa-vis-yes {
                  .fa-icon {
                    color: @greenTick;
                  }
                }
              }

              .testo {
                height: 50px;
                padding: 0 5px !important;
                .set-font(@size: 12px; @color: @textTable);
                text-align: left;
                word-break: break-word;
              }

              .footer {
                display: inline-block;

                //position: absolute;
                //bottom: 6px;
                //left: 0;
                //padding: 0 10px !important;
                .data {
                  .set-font(@color: #9AA0A7, @size: 11px);
                  float: left;
                  line-height: 20px;
                  //font-style: italic;
                  padding-top: 2px;
                }

                .el-button {
                  width: 80px !important;
                  float: right;
                  padding: 0 6px;
                  height: 26px !important;
                }

                .skip {
                  float: right;
                  margin-right: 2px;
                  text-align: right;

                  .el-badge {
                    .fa-icon {
                      color: #007E85;
                    }

                    .el-badge__content {
                      border: none;
                      background-color: transparent;
                      color: #007E85;
                      right: 10px;
                    }
                  }
                }
              }
            }
          }

          & .selected {
            background-color: @hoverTbl;
          }

          & .important {
            border-left: 3px solid @rossoRiva;

            .testo {
              word-break: break-word;
              .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
            }

            .footer {
              .data {
                .set-font(@color: #9AA0A7, @size: 11px, @family: 'os-bold') !important;
                font-style: normal;
              }
            }
          }
        }
      }
    }
  }
}

.modal-message-mobile {
  .custom-dialog {
    height: 80% !important;
    width: 98% !important;
    margin-top: 20% !important;
  }

  .el-dialog {
    .el-dialog__body {
      height: -moz-calc(100% - 200px);
      height: -webkit-calc(100% - 200px);
      height: calc(100% - 200px);
      overflow: auto;
      padding-left: 0px;
      padding-right: 0px;

      .data {
        width: 100%;
        text-align: right;
        margin-top: 10px;
        .set-font(@size: 12px, @color: @textTable);
        font-style: italic;
        padding: 0 4px !important;
      }

      .priorita {
        margin-top: 15px;
        text-align: left;

        .prior-label {
          .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
        }

        .prior-value {
          margin-left: 2px;
          .set-font(@color: red, @size: 14px, @family: 'os-semibold');
        }

        .prior-icon {
          .fa-icon {
            color: red;
            margin-top: -4px;
            margin-left: 2px;
          }
        }
      }

      .testo {
        margin-top: 20px;
        .set-font(@color: @textTable, @size: 13px);
        text-align: justify;
        height: auto;
        overflow: auto;
        padding-right: 5px !important;
        word-break: break-word;
      }

      .allegati {
        min-height: 30px;
        max-height: 120px;
        overflow: auto;
        margin-top: 30px;
        margin-bottom: 20px;

        .allegato {
          display: inline-block;

          .icona {
            width: 10%;
            float: left;
            padding-top: 2px;
          }

          .titolo-allegato {
            width: 85%;
            float: left;
            .set-font(@color: @greenRiva, @size: 13px);
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .allegato:hover {
          cursor: pointer;
        }
      }
    }

    .el-dialog__footer {
      padding: 10px 0 0;
      height: 160px;

      .footer {
        height: 45px;
        width: 100%;
        padding: 0 !important;

        .scade {
          padding: 10px 0 0 15px;
          .set-font(@color: @textTable, @size: 12px);
          font-style: italic;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Documenti/Comunicazioni.vue